var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-main"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"image",attrs:{"src":_vm.errorpage}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px"}},[_c('label',{staticClass:"loginButton",on:{"click":_vm.back}},[_vm._v("返 回")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e459676a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/modules/errorPages/norightpage.vue
// module id = null
// module chunks = 